<template>
  <div>
    <div class="row text-left mb-2">
      <div class="col-sm-12 col-md-4 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-store"></i>
              </label>
              <multiselect
                v-model="selectedOutlet"
                label="text"
                track-by="id"
                :options="outlet"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="selectOutlet"
              >
                <template slot="option" slot-scope="{ option }">{{
                  option.text
                }}</template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-user"></i>
              </label>
              <multiselect
                v-model="selectedStaff"
                :options="staffs"
                track-by="staffID"
                label="name"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="selectStaff"
              >
                <template slot="option" slot-scope="{ option }">{{
                  option.name
                }}</template>
                <span slot="noResult">{{ $t("table.no_records") }}</span>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <a class="col-sm-12 col-md-4 link text-primary" @click="clearFilter()">{{
        $t("button_link.clear_filter")
      }}</a>
    </div>
    
    <div class="wrap">
      <div class="content">
        <FullCalendar :options="calendarOptions">
            <template v-slot:eventContent='arg'>
      <div class="card w-100 border-left-primary">
       <div class="card-body text-light d-flex flex-column">
         <b>{{ arg.event.title }}</b>
          <b>{{ arg.event.extendedProps.sku }}</b>
           <b>{{ arg.event.extendedProps.member }}</b>
       </div>
      </div>
    </template>
        </FullCalendar>
      </div>
      <!-- <div class="panel-tag mt-3 col-sm-6 col-md-6 col-lg-6 h-50" v-if=" totalEntries == 0">
      {{ $t("table.no_records") }}
    </div> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import FullCalendar from "@fullcalendar/vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { handleSessionExpired } from "../../../../assets/js/dashboard/dashboard";
export default {
  name: "Calendar",
  components: {
    FullCalendar,
  },
  data: function () {
    let now = moment();
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        defaultDate: now.startOf('week'),
        initialView: "dayGridMonth",
        events: [],
        headerToolbar: {
    left: 'prev,next',
    center: 'title',
    right: 'dayGridMonth,dayGridWeek,dayGridDay' // user can switch between the two
  }
      },
      dateRange: {
        startDate: now.startOf("month").toDate(),
        endDate: now.add(4, "month").endOf("month").toDate(),
      },
      staffs: [],
      outlet: [],
      outletID: "",
      staffID: "",
      apptLists: [],
      totalEntries: 0,
      apptData: [],
      dp: {},
      events: [],
      selectedStatus: "all",
      selectedStaff: {
        staffID: "",
        name: "All Staffs",
      },
      selectedOutlet: {
        text: "All Outlets",
        bizName: "All Outlets",
        id: "",
      },
      attr: [],
    };
  },
  methods: {
    selectOutlet(val) {
      this.outletID = val.id;
      this.selecetdOutlet = val;
      this.selectedStaff = {
        staffID: "",
        name: "All Staffs",
      };
      this.staffID = "";
      this.setAppointmentList();
    },
    selectStaff(val) {
      this.staffID = val.staffID;
      this.setAppointmentList();
    },
    clearFilter() {
      this.selectedStaff = {
        staffID: "",
        name: "All Staffs",
      };
      this.selectedOutlet = {
        text: "All Outlets",
        bizName: "All Outlets",
        id: "0",
      };
    },
    async setAppointmentList() {
      this.isSpinnerShow = true;
      let $vm = this;
      var result = await this.getAppointmentList();
      this.outlet = [];
      this.outlet = this.outlet.concat(JSON.parse(this.$store.state.outlets));
      this.selectedOutlet =
        this.selectedOutlet.id == "" ? this.outlet[0] : this.selectedOutlet;
      this.apptLists = result.books;
      const sku = result.skus;
      const members = result.members;
      const staffs = result.staffs;
      const colors = result.colors;
      this.staffs = [{ staffID: "", name: "All Staffs" }];
      this.staffs = this.staffs.concat(staffs);
      // this.staffs = this.staffs.filter(staff => {
      //   if(staff.outletID == this.selectedOutlet.id)
      //   return staff;
      // });
      this.apptLists.forEach((books) => {
        books.arrivalDate = moment(new Date(books.arrivalDate * 1000)).toDate();
        books.createDate = moment(new Date(books.createDate * 1000)).format();
        books.sku = sku.filter((item) => {
          if (item.skuID == books.skuID) return item;
        })[0].name;
        var member = members.filter((item) => {
          if (item.memberID == books.memberID) return item;
        })[0];
        books.member = member.name;
        books.mobile = member.mobile;
        books.staff = staffs.filter((item) => {
          if (item.staffID == books.staffID) return item;
        })[0].name;
        books.color = colors.filter((item) => {
          if (item.colorID == books.colorID) return item;
        })[0].name;
      });
      this.apptLists = this.apptLists.filter((item) => {
        if (
          item.staffID.toString().includes(this.staffID) &&
          item.outletID.toString().includes(this.outletID)
        ) {
          switch (this.selectedStatus) {
            case "all":
              return item;

            case "completed":
              if (item.completedDate != 0) return item;
              break;
            case "noshow":
              if (item.noshowDate != 0) return item;
              break;
            case "approved":
              if (item.completedDate === 0 && item.noshowDate === 0)
                return item;
          }
        }
      });
      this.totalEntries = this.apptLists.length;
      this.loadPickerData();
    },
    async loadPickerData() {
      let attr = [];
      this.apptLists.forEach((element) => {
        var obj = {};
        obj.key = "today";
        obj.dates = element.arrivalDate;
        obj.start = moment(element.arrivalDate).format("hh:mm a");
        obj.end = moment(element.arrivalDate)
          .add(element.duration, "m")
          .format("hh:mm a")
          .slice(0, 19);
        // obj.backColor = "#6aa84f";
        // obj.borderColor = "#38761d";
        obj.highlight = {
          color: "red",
          fillMode: "solid",
        };
        attr.push(obj);
        this.calendarOptions.events.push({
          title: `${obj.start}-${obj.end}`,
          member:element.member,
          sku:element.sku,
          classNames:"calendarEvents",
          date: element.arrivalDate,
        });
      });
      this.attr = attr;
    },
    async getAppointmentList() {
      let $vm = this;
      let QUERY_STRING = "";
      if (this.dateRange.startDate != "" && this.dateRange.stopDate != "") {
        this.dateRange.startDate.setHours(0, 0, 0, 0);
        this.dateRange.endDate.setHours(23, 59, 59, 999);
        QUERY_STRING =
          "?start=" +
          Date.parse(this.dateRange.startDate).toString().slice(0, 10) +
          "&stop=" +
          Date.parse(this.dateRange.endDate).toString().slice(0, 10);
      }

      if (this.outletID != 0) {
        QUERY_STRING = QUERY_STRING + "&outletID=" + this.outletID;
      }
      let url = this.$api.BOOKING + QUERY_STRING;

      var result = {};
      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: "https://appt.tunai.io/",
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
  },
  mounted() {
    this.setAppointmentList();
  },
};
</script>

<style>

.wrap {
  display: flex;
}

.left {
  margin-right: 10px;
}

.content {
  flex-grow: 1;
}
</style>
